
import React from "react";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import type { Conversation } from "./types/conversation";

interface ConversationItemProps {
  conversation: Conversation;
  isActive: boolean;
  onSelect: (threadId: string) => void;
  onDelete: (conversation: Conversation, e: React.MouseEvent) => void;
}

const ConversationItem: React.FC<ConversationItemProps> = ({
  conversation,
  isActive,
  onSelect,
  onDelete,
}) => {
  // Use display_date since we'll never know if title column exists
  const primaryText = conversation.display_date ? `Samtale ${conversation.display_date}` : `Samtale ${new Date(conversation.updated_at).toLocaleString()}`;
  
  return (
    <div
      onClick={() => onSelect(conversation.thread_id)}
      className={`p-3 rounded-md cursor-pointer flex justify-between items-start group hover:bg-muted/70 ${
        isActive ? "bg-muted/70" : ""
      }`}
    >
      <div className="overflow-hidden">
        <h4 className="font-medium text-sm truncate">
          {primaryText}
        </h4>
        <p className="text-xs text-muted-foreground truncate">
          Klikk for å se samtalehistorikk
        </p>
      </div>
      <Button
        variant="destructive"
        size="sm"
        className="opacity-0 group-hover:opacity-100 h-6 w-6 p-0 bg-soft-pink hover:bg-red-100 text-red-500"
        onClick={(e) => onDelete(conversation, e)}
      >
        <Trash2 className="h-4 w-4" />
        <span className="sr-only">Slett samtale</span>
      </Button>
    </div>
  );
};

export default ConversationItem;
